import { connectSurchargePercentLabel } from './connectSurchargePercentLabel';
import { SurchargePercentLabel as SurchargePercentLabelPure } from './SurchargePercentLabel';

export const SurchargePercentLabel = connectSurchargePercentLabel(SurchargePercentLabelPure);
